<template>
  <div class="hello flex">
    <volLeft></volLeft>
    <div class="right" v-show="add">
      <div class="add" @click="addnew">
        添加新志愿
      </div>
      <el-table :data="record" stripe border style="width: 100%;margin-top: 40px;">
        <el-table-column prop="create_time" label="创建时间">
        </el-table-column>
        <el-table-column prop="batch_name" label="批次">
        </el-table-column>
        <el-table-column prop="enroll_type" label="科目">
        </el-table-column>
        <el-table-column prop="score" label="分数">
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <span style="color: #C10B17;cursor: pointer;" @click="editor(scope.row)">
              编辑
            </span>
            <span @click=" del(scope.row)" style="cursor: pointer;">
              删除
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="page"
        style="margin-top: 60px;" @current-change="current_change" v-if="pageshow">
      </el-pagination>
    </div>

    <!-- 遮罩层 -->
    <!-- <div id="mask" ref="mask" v-show="dialogTableVisible">
      <popup :show='dialogTableVisible'></popup>
    </div> -->
    <div id="mask" ref="mask" v-show="popupshow">

    </div>
    <!-- 确认填报信息弹框 -->
    <div id="mask" ref="mask" v-show="dialogTableVisible1">
      <div class="confirm">
        <i class="el-icon-close" style="position: absolute;right: 15px;top: 15px;"
          @click="dialogTableVisible1=false"></i>
        <div class="head">
          <span :class="current==0?'selected':''" @click="current=0">1.请确认高考信息</span><span
            :class="current==1?'selected':''" @click="current=1">2.请选择填报批次</span>
        </div>
        <div class="form" v-if="current==0">
          <div>
            <span>高考省份</span>
            <input type="text" v-model="userInfo.province_name" disabled>
            <span class="right_tip">
              <img src="../../assets/suo.png" alt="">
            </span>
          </div>
          <div style="text-align: left;margin-left: 29px;">
            <span>高考科目</span>
            <span style="margin-left: 42px;">
              <el-radio v-model="userInfo.subject_type_1" style="font-size: 16px;" label="2" fill="#C10B17"
                text-color='#C10B17' disabled>历史
              </el-radio>
              <el-radio style="font-size: 16px;" label="1" v-model="userInfo.subject_type_1" disabled>物理</el-radio>

            </span>
          </div>
          <div>
            <span>高考分数</span>
            <input type="text" v-model="userInfo.score" disabled>
            <span class="right_tip">
              <span>分</span>
              <img src="../../assets/suo.png" alt="" style="vertical-align: text-top;">
            </span>
          </div>
          <div>
            <span>对应排名</span>
            <input type="text" v-model="userInfo.score_rank" disabled>
            <span class="right_tip">
              <span>名</span>
              <img src="../../assets/suo.png" alt="">
            </span>
          </div>
          <!-- <div style="text-align: left;margin-left: 29px;">
            <span>志愿模式</span>
            <el-select v-model="type" placeholder="请选择志愿类型" style="margin-left: 38px!important;width: 200px;"
              @change="changetype">
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div> -->
          <button @click="current=1">
            确定
          </button>
        </div>

        <div class="form" v-if="current==1">
          <div class="batch">
            <div class="listone1 flex" v-for="(item,index) in options" @click="check(item)">
              <div class="left">
                <div class="left1">
                  {{item.name}}
                </div>
                <div class="left2">
                  共{{item.school_num}}个院校/{{item.major_num}}个专业招生
                </div>
              </div>
              <img v-show="item.checked==true" src="../../assets/selected.png" alt="">
            </div>
            <button class="sure" @click="sure">
              确认填报
            </button>
          </div>
        </div>
      </div>
    </div>

    <open v-show="add==false"></open>
  </div>
</template>

<script>
  import open from '../../components/open.vue'
  import popup from '../../components/popup.vue'
  import schoolFilter from '../../components/schoolfilter.vue'
  import volLeft from '../../components/volLeft.vue'
  export default {
    data() {
      return {
        add: true,
        total: '',
        page: 1,
        pageshow: true,
        record: [],
        type: 'score',
        typeList: [{
            label: '分数选志愿',
            value: 'score'
          }, {
            label: '同位分报志愿',
            value: 'equal'
          },
          {
            label: '线差报志愿',
            value: 'diff'
          },
          {
            label: '位次报志愿',
            value: 'rank'
          },
          {
            label: 'PNMP报志愿',
            value: 'pnmp'
          }
        ],
        popupshow: false,
        tabindex: 0,
        rangevalue: [30, 100],
        formInline: {
          user: '',
          region: ''
        },
        marks: {
          30: '500',
          68: '520',
          88: '570'
        },
        data: [],
        zhuanye_total: 0,
        zhuanye_page: 1,
        page: 1,
        current: 0,
        activeName: 'first',
        dialogTableVisible: false,
        dialogTableVisible1: false,
        radio: 2,
        userInfo: [],
        options: [],
        batch: '',
        id: '',
        loading: false,
        school_id: '',
        school_pos: '',
        school: [],
        tableData: [],
        tableList: [],
        checkedSchool: [],
        popover_content: '',
        zhuanye: [],
        checkedSchool: [],
        checkedId: [],
        old: [], //最开始的数据
        one_major: [],
        score: '',
        userInfo: [],
        year: 2022,
        page: 1,
        id: ''
      }
    },
    components: {
      popup,
      schoolFilter,
      volLeft,
      open
    },
    created() {
      this.type = this.$route.query.type
      if (localStorage.getItem('token')) {
        this.$http.getUserInfo().then(res => {
          this.userInfo = res.data
        })
      } else {
        this.$message.warning('请先登录')
        this.$store.commit('login', true)
      }
      this.$http.customCheckList({
        from_type: this.type == 'self' ? 3 : 1,
        base_on: this.type == 'self' ? 'score' : this.$route.query.type
      }).then(res => {

        if (this.type == 'self') {
          this.record = res.data.list.filter(item => {
            return item.is_check == 0
          })
          this.total = this.record.length
        } else {
          this.total = res.data.count
          this.record = res.data.list
        }
        //
        // if (res.data.list.length != 0) {
        //   this.add = true
        // }
      })
      this.$http.checkSchoolSimulated().then(res => {
        this.options = res.data.list
        this.userInfo.score_rank = res.data.rank
      })

    },
    mounted() {
      this.$nextTick(function() {
        window.addEventListener('scroll', this.onScroll)
      })
    },
    methods: {
      changetype(e) {
        this.type = e
      },
      onScroll() {
        if (this.getScrollHeight() - this.getClientHeight() - this.getScrollTop() <= 100 && this.add == false) {
          this.page++
          this.$http.checkSchoolCustomSearch({
            batch_name: '本科一批',
            page: this.page
          }).then(res => {
            this.data = [...this.data, ...res.data.list]

            this.data.forEach(item => {
              // item.history.unshift({
              //   'score_actual': item.score_actual,
              //   'score_add_avg': item.score_add_avg,
              //   'score_add_div': item.score_add_div,
              //   'score_pre_div': item.score_pre_div,
              //   'year': item.year,
              //   "province_line": item.province_line,
              //   'score_rank': item.score_rank,
              //   'enroll_plan': item.enroll_plan
              // })
            })
          })
        }
      },
      getScrollTop() {
        var scrollTop = 0
        if (document.documentElement && document.documentElement.scrollTop) {
          scrollTop = document.documentElement.scrollTop
        } else if (document.body) {
          scrollTop = document.body.scrollTop
        }
        return scrollTop
      },
      // 获取当前可视范围的高度
      getClientHeight() {
        var clientHeight = 0
        if (document.body.clientHeight && document.documentElement.clientHeight) {
          clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight)
        } else {
          clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight)
        }
        return clientHeight
      },

      // 获取文档完整的高度
      getScrollHeight() {
        return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
      },
      current_change(e) {
        this.page = e
        this.$http.customCheckList({
          from_type: this.type == 'self' ? 3 : 1,
          base_on: this.type == 'self' ? 'score' : this.$route.query.type,
          page: this.page
        }).then(res => {

          if (this.type == 'self') {
            this.record = res.data.list.filter(item => {
              return item.is_check == 0
            })
            this.total = this.record.length
          } else {
            this.total = res.data.count
            this.record = res.data.list
          }
          //
          // if (res.data.list.length != 0) {
          //   this.add = true
          // }
        })
      },
      surezhuanye(item) {
        // if (this.zhuanye.length == 5 && item.checked == false) {
        //   this.$message.error('最多只能填写五个专业！')
        //   return
        // }
        this.zhuanye.push(item.mid + '')
        this.one_major.push(item)
        item.visible = false
      },
      /* 保存志愿，获取结果*/
      saveAll() {
        this.$http.checkSchool({
          id: this.id
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('审核成功')
            this.$router.push(`/form?id=${this.id}`)
            localStorage.setItem('activeurl', 'form')
          }
        })
      },
      qiehuan() {
        this.$router.push(`/artificial`)
      },
      editor(item) {
        // this.id = item.id
        // this.$http.customCheckDetail({
        //   id: this.id
        // }).then(res => {
        //   res.data.result.map(item => {
        //     this.checkedId.push(item.school_id)
        //   })
        //   this.checkedSchool = res.data.result
        //   console.log(this.checkedId)
        //   this.$http.checkSchoolCustomSearch({
        //     id: this.id,
        //     batch_name: item.batch_name
        //   }).then(res => {
        //     this.data = res.data.list
        //     this.old = res.data.list
        //     this.data.forEach(item => {
        //       item.checked = false
        //     })
        //     this.add = false
        //   })
        if (this.type == 'self') {
          this.$router.push(`/independent?id=${item.id}&batch=${item.batch_name}`)
          return
        }
        if (this.type == null) {
          this.$router.push(`/artificial?id=${item.id}&batch=${item.batch_name}`)
        } else {
          this.$router.push(`/artificial?id=${item.id}&batch=${item.batch_name}&type1=${this.type}`)
        }

        // this.$forceUpdate()
        // })
      },
      del(item) {
        this.$http.intentionDelete({
          id: item.id
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('删除成功')
            // this.$http.customCheckList().then(res => {
            //   this.record = res.data.list
            // })
            this.$http.customCheckList({
              from_type: this.type == 'self' ? 3 : 1,
              base_on: this.type == 'self' ? 'score' : this.$route.query.type
            }).then(res => {

              if (this.type == 'self') {
                this.record = res.data.list.filter(item => {
                  return item.is_check == 0
                })
                this.total = this.record.length
              } else {
                this.total = res.data.count
                this.record = res.data.list
              }
              //
              // if (res.data.list.length != 0) {
              //   this.add = true
              // }
            })
          }
        })

      },
      /* 添加新志愿*/
      addnew() {
        this.add = true
        this.dialogTableVisible1 = true
      },
      /* 筛选学校*/
      filter(e) {


      },
      /* 搜索学校*/
      searchSchool(e) {
        this.$http.checkSchoolCustomSearch({
          id: this.id,
          name: e
        }).then(res => {
          this.data = res.data.list
        })
      },
      /* 清空搜索条件*/
      clear() {
        this.data = this.old
      },
      /* 保存选完专业的学校*/
      savezhuanye() {
        // let result = this.tableList.filter(item => {
        //   return item.checked == true
        // })
        let data = {
          major: this.one_major,
          school_pos: this.school_pos,
          id: this.id
        }
        if (this.zhuanye.length > 5) {
          this.$message.error('最多可填5个专业!')
          return
        }
        this.$http.aiMajorChange(data).then(res => {
          if (res.code == 200) {
            this.$message.success('保存成功!')
            this.popupshow = false
            this.tableList = []
            this.tableData = []
            setTimeout(() => {
              this.$http.customCheckDetail({
                id: this.id
              }).then(res => {
                this.data = res.data.result
                this.$forceUpdate()
              })
            })
          }
        })

      },
      tianbaozhuanye(item) {
        item.checked = !item.checked
        if (this.zhuanye.indexOf(item.mid + '') > -1) {
          this.zhuanye.splice(this.zhuanye.indexOf((item.mid + '')), 1)
          this.one_major.splice(this.zhuanye.indexOf((item.mid + '')), 1)
        } else {
          if (this.zhuanye.length == 5 && item.checked == false) {
            this.$message.error('最多只能填写五个专业！')
            return
          }
          this.lookplan(item, 2)
        }

      },
      //查看招生计划
      lookplan(item, num) {
        this.popover_content = ''
        this.tip = ''
        this.$http.schoolEnrollPlan({
          major_name: item.major_name,
          school_id: this.school_id
        }).then(res => {
          if (num == 2) {
            item.visible = true
          } else {
            item.visible1 = true
          }
          // item.visible = true
          if (res.data.list.length == 0) {
            this.popover_content = '暂无专业详情'
            return
          }
          if (res.data.list[0].enroll_limit == true) {
            this.tip = `此专业有报考限制条件，请注意查看说明---`
            this.popover_content = res.data.list[0].year + res.data.list[0].major_name +
              ';    招生人数:' + res.data.list[
                0]
              .num + '   费用:' + res.data.list[0].money_year +
              '    说明:' + res.data.list[0].major_detail
          } else {
            this.popover_content = res.data.list[0].year + res.data.list[0].major_name +
              ';    招生人数:' + res.data.list[
                0]
              .num + '   费用:' + res.data.list[0].money_year +
              '    说明:' + res.data.list[0].major_detail
          }
          this.popover = true
        })
      },
      /* 切换专业历史录取的年份 */
      tabchange(item, index) {
        let data = {
          id: this.id,
          school_id: this.school_id,
          year: item.label
        }
        this.year = item.label
        this.zhuanye_page = 1
        this.tableList = []
        this.$http.checkMajorCustomSearch(data).then(res => {
          this.tableList = res.data.list
          // this.tableList = res.data.list.map(item => {
          //   return item.checked == false
          // })
          this.tabindex = index
          // this.$forceUpdate()
        })
      },

      /* 点击填报学校*/
      tianbao(item, index) {
        console.log(item)
        this.zhuanye = []
        this.one_major = []
        this.school_id = item.school_id
        this.school = item
        this.school_pos = index
        let data = {
          id: this.id,
          school_id: item.school_id,
          pc: 1
        }

        this.$http.checkMajorCustomSearch(data).then(res => {
          this.tableData = res.data
        })

      },
      change() {
        this.dialogTableVisible = true

      },
      check(item) {
        this.batch = item.name
        this.options.forEach(item1 => {
          item1.checked = false
        })
        item.checked = true
      },
      sure() {
        // if (this.batch == '') {
        //   this.$message.warning('请先选择批次')
        //   return
        // }
        this.$http.customSchoolNew({
          batch: this.batch,
          base_on: this.type == 'self' ? 'score' : this.type,
          from_type: this.type == 'self' ? 3 : 1
        }).then(res => {
          if (res.code == 200) {
            this.id = res.data.id
            this.dialogTableVisible1 = false
            this.add = false
            this.$http.checkSchoolCustomSearch({
              id: this.id,
              batch_name: this.batch
            }).then(res => {
              this.data = res.data.list
              this.old = res.data.list
              this.data.forEach(item => {
                item.checked = false

              })
            })
            this.$http.customCheckDetail({
              id: this.id
            }).then(res => {
              this.school_pos = res.data.result.length
              this.checkedSchool = this.data.map(item => {
                return item.school_id
              })
            })
            if (this.type == 'self') {
              this.$router.push(`/independent?id=${this.id}&batch=${this.batch}&type1=${this.type}`)
              return
            }
            this.$router.push(`/artificial?id=${this.id}&batch=${this.batch}&type1=${this.type}`)
          }
        })
      }

    }
  }
</script>

<style scoped lang="scss">
  $color:#C10B17;

  .zhuanye_one {
    padding: 20px 0px;
    border-bottom: 1px solid #CCCCCC;
    width: 100%;
    justify-content: space-between;

    button {
      width: 74px;
      height: 32px;
      background: #C10B17;
      border-radius: 4px;
      color: #FFFFFF;
    }
  }

  .tableone {
    width: 100%;
    justify-content: space-between;

    button {
      width: 74px;
      height: 32px;
      background: #C10B17;
      border-radius: 4px;
      color: #FFFFFF;
    }
  }

  .nav {
    display: flex;
    width: 300px;
    align-items: flex-end;
  }

  .nav .item {
    flex: 1;
    height: 40px;
    line-height: 40px;
    background: #F2F2F2;
    border-radius: 0px;
    position: relative;
    list-style: none;
  }

  .lei {
    display: block;
    width: 24px;
    height: 24px;
    background-color: red;
    border-radius: 5px;
    color: #fff;
    line-height: 24px;
    margin-right: 7px;
    text-align: center;
    margin: 0 auto 10px auto;
  }

  .nav .item.active {
    height: 45px;
    background: $color;
  }

  .nav .item:first-child:before {
    content: '';
    display: none;
    width: 10px;
    height: 100%;
    background: $color;
    position: absolute;
    right: -5px;
    top: 0;
    z-index: 10;
    border-radius: 0 5px 0 0;
    transform: skew(10deg);
  }

  .nav .item:first-child.active:before {
    display: block;
  }

  .nav .item:last-child:before {
    content: '';
    display: none;
    width: 10px;
    height: 100%;
    background: $color;
    position: absolute;
    left: -5px;
    top: 0;
    z-index: 10;
    border-radius: 5px 0 0 0;
    transform: skew(-10deg);
  }

  .nav .item:last-child.active:before {
    display: block;
  }

  .add {
    width: 980px;
    height: 50px;
    line-height: 50px;
    background: #C10B17;
    border: 1px solid #C10B17;
    border-radius: 4px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
  }

  .batch {
    image {
      width: 28px !important;
      height: 22px;
    }

    .listone1 {
      margin: 10px 44px;
      border: 1px solid #E6E6E6;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 22px;
      text-align: left;

      text {
        font-size: 16px;
        color: #797373 !important;
        margin-right: 19px;
      }

      image {
        width: 14px;
        height: 25px;
      }

      .left1 {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        margin-top: 14px;
      }

      .left2 {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        margin: 19px 0 15px 0;
      }

      .left3 {
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #C10B17;
      }
    }
  }

  .confirm {
    width: 558px;
    // height: 456px;
    background: #FFFFFF;
    border-radius: 10px;
    z-index: 1000;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -279px;
    margin-top: -228px;

    button {
      width: 100px;
      height: 40px;
      background: #C10B17;
      border-radius: 20px;
      border: none;
      outline: none;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }

    .right_tip {
      position: absolute;
      right: 30px;
      top: 10px;
    }

    .form>div {
      margin-bottom: 34px;
      position: relative;

      span {
        width: 64px;
        height: 15px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }

    .form input {
      width: 387px;
      height: 41px;
      border: 1px solid #E6E6E6;
      border-radius: 20px;
      outline: none;
      margin-left: 38px;
      text-indent: 23px;
    }

    .head {
      margin: 47px 77px 44px 70px;

      span {
        display: inline-block;
        width: 50%;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #999999;
      }
    }
  }

  .form {
    padding-bottom: 40px;
  }

  .sure {
    width: 299px !important;
    height: 40px;
    background: #C10B17;
    border-radius: 20px;
    margin-top: 27px;
  }

  .selected {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333 !important;
  }

  .current1 {
    width: 600px;

    line-height: 46px;
    margin-bottom: 12px;
    text-align: left;
    border: 1px solid #EDEDED;



    span {
      display: inline-block;
      text-align: center;
      background-color: #F2F2F2;
    }



    .dangqian {
      width: 236px;
    }

    .change {
      display: inline-block;
      width: 200px;
      height: 46px;

      color: #666666;
    }

    .actived {
      background-color: #FFFFFF;
      color: $color;
    }
  }

  #mask {
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 998;
    height: 100vh;
  }

  .tablemain {
    &>div {
      // flex: 1;
      text-align: center;
    }

    border-bottom: 1px solid #F2F2F2;
    padding: 18px 0;

    .shuju span {
      display: block;
      margin: 5px auto;
      width: 24px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      background: rgba(207, 202, 204, 0.1);
      border: 1px solid #B0B0B0;
      color: #B0B0B0;
      border-radius: 5px;
    }

    .shuju1 span {
      display: block;
      margin: 5px auto;
      width: 24px;
      height: 24px;
      line-height: 24px;
      border: 1px solid transparent;
      text-align: center;
      border-radius: 5px;
    }

    .btn {
      width: 74px;
      height: 32px;
      line-height: 32px;
      color: #ffffff;
      background: #C10B17;
      border-radius: 4px;
    }

    .info {

      text-align: center;

      img {
        width: 67px;
        height: 67px;
        border-radius: 50%;
        margin-right: 15px;
      }
    }
  }

  .tablehead {
    text-align: left;

    width: 979px;
    height: 51px;
    background: #FAFAFA;
    line-height: 51px;
    // margin-top: 20px;

    span {
      display: inline-block;
      // flex: 1;
      text-align: center;
    }

    // & span:nth-child(2) {
    //   flex: 3
    // }

    // & span:nth-child(3) {
    //   flex: 2
    // }
  }

  main {
    margin-top: 51px;

    .choosetype {
      text-align: left;

      .active {
        font-weight: 400;
        color: #C10B17;
        background: #D1F4F4;
      }

      span {
        display: inline-block;
        width: 107px;
        height: 36px;
        line-height: 36px;
        border-radius: 4px 0px 0px 0px;
        border: 1px solid #F2F2F2;
        border-radius: 4px 0px 0px 0px;
        text-align: center;
      }
    }
  }

  .filter1 {
    justify-content: space-around;
    margin: 29px 20px;
  }

  .filter2 {
    justify-content: space-between;

    .clear {
      width: 60px;
      height: 36px;
      border: 1px solid #C10B17;
      border-radius: 6px;
      color: #C10B17;
      background-color: #ffffff;
      color: #C10B17 !important;
    }

    .flex {
      flex-wrap: nowrap;

      span {
        width: 100px
      }
    }

    margin: 0px 20px;
  }

  .right {
    margin-left: 16px;
  }

  .filter {
    width: 979px;
    height: 149px;
    border: 1px solid #EDEDED;
    border-radius: 10px;
  }

  .score {
    width: 176px;
    height: 80px;
    border-radius: 6px;
    background-color: #E8FAFA;
    margin: 18px auto;
    line-height: 25px;
    color: #C10B17
  }

  .line {
    margin: 25px 0 18px 0;
    color: #C10B17
  }

  .info {
    // width: 205px;
    background: #FFFFFF;
    border-radius: 10px;
    margin-top: 18px;

    button {
      width: 177px;
      height: 33px;
      border: 1px solid #C10B17;
      border-radius: 6px;
      background-color: #FFFFFF;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #C10B17;
      margin-top: 15px;
    }

    &>p {
      width: 100%;
      text-align: left;
      margin: 20px 0px 20px 24px;
    }

    .head {
      height: 60px;
      background: #C10B17;
      border-radius: 10px;
      line-height: 60px;
      color: #FFFFFF;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
  }

  // .change {
  //   width: 205px;
  //   height: 151px;
  //   background: #FFFFFF;
  //   border: 1px solid #EDEDED;
  //   border-radius: 10px;

  //   p {
  //     width: 204px;
  //     height: 50px;
  //     line-height: 50px;
  //   }
  // }

  .hello {
    width: 1280px;
    margin: 20px auto;
    align-items: flex-start;
  }

  .active {
    background: #C10B17;
    color: #FFFFFF;

  }

  .tabactive {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #C10B17;
    border-bottom: 3px solid #C10B17;
  }

  .type {
    // margin-top: 22px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-align: left;

    span {
      margin: 0 5px 5px 0;
    }
  }

  .name {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }

  .address {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    margin-left: 10px;
  }

  .popuptitle {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #E6E6E6;
    text-indent: 40px;
  }

  .popup2 {
    width: 800px;
    height: 654px;
    background: #e8ffc9;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -400px;
    margin-top: -327px;
    overflow: hidden;
  }

  .caozuo {
    margin-top: 30px;
  }

  .popup1 {
    width: 1100px;
    padding-bottom: 40px;
    background: #ffffff;
    border-radius: 10px;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -495px;
    margin-top: -327px;
    overflow: hidden;
    z-index: 999;

    .popuphead {
      width: 100%;
      line-height: 40px;
      height: 40px;
      border-bottom: 1px solid #E6E6E6;
      justify-content: space-between;

      p {
        margin-left: 20px;
      }

      i {
        margin-right: 20px;
      }
    }
  }

  .tableHead1 {
    width: 1000px;
    margin: 0 auto;
    height: 40px;
    background: #FAFAFA;
    border-radius: 4px;
    line-height: 40px;

  }

  .tableHead1 span {
    width: 120px;
    color: #999999;
  }

  .table1 {
    width: 100%;
    justify-content: space-around;
    margin-top: 40px;
  }

  .tableHead {
    margin-top: 40px;
    justify-content: space-between;
  }
</style>
<style lang="scss">
  // 添加颜色类
  .el-radio__input.is-checked+.el-radio__label {
    color: #C10B17 !important;
    font-size: 16px
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: #C10B17 !important;
    border-color: #C10B17 !important;
    font-size: 16px
  }

  .el-collapse-item__header {
    height: auto;
  }

  .el-collapse-item__arrow {
    display: none;
  }

  .el-slider__bar {
    background-color: #C10B17;
  }

  .el-slider__button {
    border: 2px solid #C10B17;
  }
</style>



// WEBPACK FOOTER //
// src/view/volunteer/artificialList.vue